// subscriptionsService.js
import dataProvider from "core/DataProvider";
import toast from "react-hot-toast";

 const fetchSubscriptions = async (groupId) => {

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-GB"); // "en-GB" gives DD/MM/YYYY format
      };

    try {
      const grp_clients_sub = await dataProvider.network.post("renewal/group/clients/subs", { group_id: groupId });

      return grp_clients_sub.map((x) => ({
        ...x,
        sub_id: x.id,
        client_id: x.client_id,
        client_name: x.client_name,
        advertiser: x.advertiser,
        period_from: formatDate(x.subscription_from),
        period_to: formatDate(x.subscription_to),
      }));
    } catch (error) {
      toast.error("Failed to load group subscriptions");
      return [];
    }
  };

  export default fetchSubscriptions;